<template>
  <span
    v-if="isParsing"
    class="c-aiSuggestChip c-aiSuggestChip--muted"
  >
    <v-progress-circular
      indeterminate
      color="grey"
      size="14"
      width="2"
    />
    <span class="ms-1">解析中</span>
  </span>
  <span
    v-else-if="isSuggested"
    class="c-aiSuggestChip c-aiSuggestChip__label c-aiSuggestChip--filled"
  >
    <SparkleIcon />
    <span class="ms-1">AI提案</span>
  </span>
  <span
    v-else-if="isConfirmed"
    class="c-aiSuggestChip c-aiSuggestChip--done c-aiSuggestChip--filled"
  >
    <v-icon
      size="14"
      color="correctionBlue"
    >
      mdi-check
    </v-icon>
    <span class="ms-1">採用済み</span>
  </span>
  <span
    v-else-if="isRevised"
    class="c-aiSuggestChip c-aiSuggestChip--revised c-aiSuggestChip--filled-revised"
  >
    <v-icon
      size="14"
      color="#33B5B4"
    >
      mdi-check
    </v-icon>
    <span class="ms-1">手動編集済み</span>
  </span>
  <span
    v-else-if="isEmpty"
    class="c-aiSuggestChip c-aiSuggestChip--danger c-aiSuggestChip--filled-danger"
  >
    <v-icon size="14">
      mdi-alert-circle-outline
    </v-icon>
    <span class="ms-1">要記入</span>
  </span>
</template>

<script>
import SparkleIcon from "@/vue/components/images/sparkleIcon.vue";

export default {
  name: "AiSuggestChip",
  components: {
    SparkleIcon,
  },
  props: {
    status: {
      type: String,
      default: "",
    },
  },
  computed: {
    isParsing() {
      return this.status === "parsing";
    },
    isSuggested() {
      return this.status === "suggested";
    },
    isConfirmed() {
      return this.status === "confirmed";
    },
    isRevised() {
      return this.status === "revised";
    },
    isEmpty() {
      return this.status === "empty";
    },
  },
};
</script>

<style scoped lang="scss">
.c-aiSuggestChip {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  font-size: 12px;
  line-height: 1;

  &--muted {
    color: #64748b;
  }

  &--done {
    color: rgb(var(--v-theme-correctionBlue));
  }

  &--revised {
    color: #33B5B4;
  }
  &--danger {
    color: #dc2626;
  }

  &__label {
    color: rgb(var(--v-theme-correctionBlue));
  }

  &--filled {
    background-color: #e8f2fe;
    border-radius: 4px;
    padding: 4px 8px;
  }

  &--filled-danger {
    background-color: rgb(var(--v-theme-alertRedBackground));
    border-radius: 4px;
    padding: 4px 8px;
  }

  &--filled-revised {
    background-color: #EFFAFA;
    border-radius: 4px;
    padding: 4px 8px;
  }
}
</style>
